module.exports = __webpack_public_path__ + "r-v3/img/pause_white.2091228c.svg";